import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

export const EditableNetIncomeName = ({
  calculation,
  hasEditAccess,
  onEditClick,
  onDeleteClick,
  onDeleteDisabledClick,
  isDeleting = false,
}) => {
  if (!hasEditAccess) {
    return (
      <div className="px-4 py-3 bg-white rounded-lg border border-gray-200">
        <h3 className="text-base font-semibold text-gray-900">{calculation?.name}</h3>
      </div>
    );
  }

  return (
    <div className="group relative px-4 py-3 bg-white rounded-lg border border-gray-200 hover:border-gray-300 hover:shadow-sm transition-all duration-200">
      <div className="flex items-center justify-between gap-3 py-[0.20rem]">
        <h3 className="text-base font-semibold flex-1 text-gray-900">{calculation?.name}</h3>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onEditClick?.(calculation)}
            className="group-hover:opacity-100 transition-opacity duration-200 p-1.5 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700"
            aria-label="Edit net income calculation"
            disabled={isDeleting}
          >
            <PencilIcon className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => {
              const budgets = calculation?.budgets || [];
              if (Array.isArray(budgets) && budgets.length > 0) return onDeleteDisabledClick?.(calculation);
              return onDeleteClick?.(calculation);
            }}
            // If used by budgets, we still allow click so we can show the info modal (same behavior as Categories).
            disabled={isDeleting}
            className={`transition-all duration-200 p-1.5 rounded-md ${
              Array.isArray(calculation?.budgets) && calculation.budgets.length > 0
                ? 'text-gray-400 hover:bg-gray-50 cursor-not-allowed'
                : 'text-red-500 hover:text-red-700 hover:bg-red-50'
            } ${isDeleting ? 'opacity-50 cursor-not-allowed' : ''}`}
            aria-label="Delete net income calculation"
          >
            <TrashIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

